import React from 'react';
import Card from 'react-bootstrap/Card';
import { Link } from 'react-router-dom';
import { getURL } from 'helpers/utils';
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import { Score as ScoreGlobal } from "components/presentation/Score"

//Generic
import {
    CompetitorBlockNoData as CompetitorBlockNoDataGeneric, CompetitorBlock as CompetitorBlockGeneric
} from "components/sports/glo/brackets/generic";
import {
    Footer as FooterGeneric, Header as HeaderGeneric
} from "components/sports/glo/todayMatches/generic";

//Sports
import { CompetitorBlock as CompetitorBlockTte, Footer as FooterTte, Header as HeaderTte } from "components/sports/glo/todayMatches/tte";



const getCompetitorType = (discipline) => {
    switch (discipline) {
        case 'BKB':
        case 'FEN':
        case 'JUD':
            return CompetitorBlockGeneric
        case 'TTE':
            return CompetitorBlockTte
        default:
            return CompetitorBlockGeneric
    }
}

const getCompetitorNoDataType = (discipline) => {
    switch (discipline) {
        case 'BKB':
        case 'FEN':
        case 'JUD':
            return CompetitorBlockNoDataGeneric
        default:
            return CompetitorBlockNoDataGeneric
    }
}

const getFooter = (discipline) => {
    switch (discipline) {
        case 'BKB':
        case 'FEN':
        case 'JUD':
        case 'TTE':
            return FooterTte
        default:
            return FooterGeneric
    }
}

const getHeader = (discipline) => {
    switch (discipline) {
        case 'BKB':
        case 'FEN':
        case 'JUD':
        case 'TTE':
            return HeaderTte
        default:
            return HeaderGeneric
    }
}

const ScoresLiveCard = ({ data, config }) => {
    const { mirs_discipline } = useUrlFriendlyToParameters()
    const CompetitorComponent = getCompetitorType(mirs_discipline)
    const CompetitorNoDataComponent = getCompetitorNoDataType(mirs_discipline)
    const FooterComponent = getFooter(mirs_discipline)
    const HeaderComponent = getHeader(mirs_discipline)
    //Copy object in order to change 
    let paramsURL = { ...useUrlFriendlyToParameters() }
    paramsURL["mirs_rsc"] = data?.eventUnit?.code
    const url = getURL({ ...paramsURL }, 'results')
    const period = data?.result?.extendedInfos?.find(i => i?.ei_code === 'LAST_COMP')?.ei_pos;

    return (<>
        <Card className={mirs_discipline === 'TTE' ? 'scores-today-match-tte' : 'scores-today-match'} >
            <Card.Header className='d-flex'>
                <HeaderComponent data={data} />
            </Card.Header>
            <Card.Body>
                {
                    data?.result?.items
                        .sort((a, b) => a.sortOrder - b.sortOrder)
                        .map((item, index) => {
                            let data = undefined
                            console.log(item)
                            return (
                                <Link key={index} to={url} >
                                    <div className={mirs_discipline === 'TTE' ? 'score-line justify-content-between d-flex flex-row ' : ' score-line d-flex flex-row  '}>
                                        {item?.participant ? <CompetitorComponent {...item} /> : <CompetitorNoDataComponent {...item} />}
                                        {/** Results in match */}
                                        <ScoreGlobal resultJson={item?.resultDataText} discipline={mirs_discipline} />
                                    </div>
                                </Link>
                            )
                        })
                }
            </Card.Body>
            <Card.Footer>
                <FooterComponent data={data} period={period} mirs_discipline={mirs_discipline} />
            </Card.Footer>
        </Card>
    </>
    );
}

export default ScoresLiveCard;